/* eslint-disable eqeqeq */
import React from "react";
import { Modal } from "react-bootstrap";
import modelManagementService from "../_services/modelManagement.service";
import Autocomplete from "../_components/Autocomplete/Autocomplete";
import authenticationService from "../_services/authentication.service";

class UpdateModelManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brandData: props.brandData,
      modelManagement: props.updateModelManagement,
      errors: {},
      isFormValid: false,
      message: "",
      isUpdated: false,
    };

    this.handleChangeVacuumModelSeries =
      this.handleChangeVacuumModelSeries.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.autoCompleteHandleChange = this.autoCompleteHandleChange.bind(this);
    this._handleRadio = this._handleRadio.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit = (e) => {
    if (this.validateForm()) {
      let { modelManagement } = this.state;
      let seriesName = modelManagement.vacuumModelSeriesMaster.filter(
        (p) => p.vacuumModelSeriesName !== ""
      );
      modelManagement.vacuumModelSeriesMaster = seriesName;

      let formData = JSON.stringify(modelManagement);
      modelManagementService
        .update(formData)
        .then((data) => this.responseShow(data))
        .catch((error) => console.log("Error :" + error));
    }
  };
  validateForm() {
    let { modelManagement } = this.state;
    let errors = {};
    let isFormValid = true;

    if (!modelManagement.brandName) {
      isFormValid = false;
      errors["brandName"] = "Enter Brand Name";
    }
    if (!modelManagement.vacuumModelName) {
      isFormValid = false;
      errors["vacuumModelName"] = "Enter Vacuum Model Name";
    }

    this.setState({
      errors: errors,
    });
    return isFormValid;
  }
  responseShow(obj) {
    this.setState({ isUpdated: obj.isSuccess, message: obj.message });
  }
  _handleRadio(event) {
    const isEnabled = event.currentTarget.value === "true" ? true : false;
    let modelManagement = this.state.modelManagement;
    modelManagement.enabled = isEnabled;
    this.setState({ modelManagement: modelManagement });
  }
  handleChange(event) {
    const { name, value } = event.target;
    const { modelManagement, errors } = this.state;

    this.setState({
      modelManagement: {
        ...modelManagement,
        [name]: value,
      },
      errors: {
        ...errors,
        [name]: "",
      },
    });
  }
  autoCompleteHandleChange(name, value) {
    if (value != undefined) {
      const { modelManagement, errors } = this.state;
      this.setState({
        modelManagement: {
          ...modelManagement,
          [name]: value,
        },
        errors: {
          ...errors,
          [name]: "",
        },
      });
    }
  }

  handleChangeVacuumModelSeries = (idx) => (e) => {
    let { name, value } = e.target;
    let { modelManagement } = this.state;

    let vacuumModelSeriesMaster = modelManagement.vacuumModelSeriesMaster;
    vacuumModelSeriesMaster[idx] = {
      id: 0,
      vacuumModelId: modelManagement.vacuumModelId,
      [name]: value,
      enabled: true,
      createdBy: authenticationService.currentUserValue.id,
    };
    this.setState({
      modelManagement: {
        ...this.state.modelManagement,
        vacuumModelSeriesMaster: vacuumModelSeriesMaster,
      },
    });
  };
  handleAddRow = () => {
    let { modelManagement } = this.state;
    const item = {
      id: 0,
      vacuumModelId: modelManagement.vacuumModelId,
      vacuumModelSeriesName: "",
      enabled: true,
      createdBy: authenticationService.currentUserValue.id,
      createdDate: null,
      lastUpdatedBy: null,
      lastUpdatedDate: null,
    };

    let vacuumModelSeriesMaster =
      this.state.modelManagement.vacuumModelSeriesMaster;
    vacuumModelSeriesMaster.push(item);
    this.setState({
      modelManagement: {
        ...this.state.modelManagement,
        vacuumModelSeriesMaster: vacuumModelSeriesMaster,
      },
    });
  };

  handleRemoveSpecificRow = (idx) => (e) => {
    const rows = [...this.state.modelManagement.vacuumModelSeriesMaster];
    rows.splice(idx, 1);
    this.setState({
      modelManagement: {
        ...this.state.modelManagement,
        vacuumModelSeriesMaster: rows,
      },
    });
  };
  render() {
    const { modelManagement, message, isUpdated } = this.state;
    console.log(this.state);
    const { updateClose } = this.props;
    return (
      <React.Fragment>
        <Modal
          show="true"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <Modal.Title>Update Model Management</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-sm-12">
                <div className="box box-primary">
                  <form name="form">
                    <div className="box-body">
                      <div className="row">
                        <div className="col-sm-12">
                          {message && (
                            <div class="alert alert-success" role="alert">
                              {message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="brandName">Brand Name</label>
                            <Autocomplete
                              id="brandName"
                              name="brandName"
                              value={modelManagement.brandName}
                              maxLength="50"
                              className={
                                "form-control" +
                                (this.state.errors.brandName ? " invalid" : "")
                              }
                              placeholder="Brand Name"
                              onClientChange={this.autoCompleteHandleChange}
                              suggestions={this.state.brandData}
                            />
                            {this.state.errors.brandName && (
                              <small class="help-block">
                                {this.state.errors.brandName}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="vacuumModelName">
                              Vacuum Model Name
                            </label>
                            <input
                              id="vacuumModelName"
                              name="vacuumModelName"
                              value={modelManagement.vacuumModelName}
                              onChange={this.handleChange}
                              maxLength="50"
                              type="text"
                              className={
                                "form-control" +
                                (this.state.errors.vacuumModelName
                                  ? " invalid"
                                  : "")
                              }
                              placeholder="Vacuum Model Name"
                            />
                            {this.state.errors.vacuumModelName && (
                              <small class="help-block">
                                {this.state.errors.vacuumModelName}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">&nbsp;</div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <label>Enable</label>
                          <div className="form-group">
                            <div class="form-check form-check-inline">
                              <label>
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="isEnabled"
                                  value="true"
                                  checked={modelManagement.enabled === true}
                                  onChange={this._handleRadio}
                                />
                                Yes
                              </label>
                            </div>
                            <div class="form-check form-check-inline">
                              <label>
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="isEnabled"
                                  value="false"
                                  checked={modelManagement.enabled === false}
                                  onChange={this._handleRadio}
                                />
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="tbl_vacuumModelSeries">
                              Vacuum Model Series
                            </label>

                            <table
                              className="table table-bordered"
                              id="tbl_vacuumModelSeries"
                            >
                              <tbody>
                                {modelManagement.vacuumModelSeriesMaster &&
                                  modelManagement.vacuumModelSeriesMaster.map(
                                    (item, idx) => (
                                      <tr id="addr0" key={idx}>
                                        <td>{idx + 1} )</td>
                                        <td>
                                          <input
                                            type="text"
                                            name="vacuumModelSeriesName"
                                            value={item.vacuumModelSeriesName}
                                            onChange={this.handleChangeVacuumModelSeries(
                                              idx
                                            )}
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          {idx > 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-outline-danger btn-sm"
                                              onClick={this.handleRemoveSpecificRow(
                                                idx
                                              )}
                                            >
                                              Remove
                                            </button>
                                          ) : null}
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </table>
                            <button
                              type="button"
                              onClick={this.handleAddRow}
                              className="btn btn-outline-primary btn-sm"
                            >
                              Add Row
                            </button>
                          </div>
                        </div>
                        <div className="col-sm-6">&nbsp;</div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <hr />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 text-center">
                          <button
                            type="button"
                            onClick={this.handleSubmit}
                            className="btn btn-primary btn-sm ml-2 ts-buttom btn btn-primary"
                          >
                            UPDATE
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            onClick={() => updateClose(isUpdated)}
                            className="btn btn-danger btn-sm ml-2 ts-buttom btn btn-primary"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
export default UpdateModelManagement;
